import type React from "react";

import { Grid2 } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { View } from "shared/containers/View";

import { ClinicPartnerActivePatients } from "./components/ClinicPartnerActivePatients";
import { ClinicPartnerAvgFunctionality } from "./components/ClinicPartnerAvgFunctionality";
import { ClinicPartnerAvgNps } from "./components/ClinicPartnerAvgNps";
import { ClinicPartnerAvgPain } from "./components/ClinicPartnerAvgPain";
import { ClinicPartnerEnrolledPatients } from "./components/ClinicPartnerEnrolledPatients";

export const ClinicPartnerAdminView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <View title={t("views.admin")} description={t("partner_admin.description")}>
      <Grid2 container spacing={3} columns={12}>
        <StyledGrid2 size={{ xs: 12, md: 6 }}>
          <ClinicPartnerActivePatients />
        </StyledGrid2>
        <StyledGrid2 size={{ xs: 12, md: 6 }}>
          <ClinicPartnerEnrolledPatients />
        </StyledGrid2>

        <StyledGrid2 size={{ xs: 12, md: 6 }}>
          <ClinicPartnerAvgFunctionality />
        </StyledGrid2>
        <StyledGrid2 size={{ xs: 12, md: 6 }}>
          <ClinicPartnerAvgPain />
        </StyledGrid2>

        <StyledGrid2 size={{ xs: 12, md: 6 }}>
          <ClinicPartnerAvgNps />
        </StyledGrid2>
      </Grid2>
    </View>
  );
};

const StyledGrid2 = styled(Grid2)`
  padding: 32px;
  background-color: #fff;
  border-radius: 12px;
`;
